import { AttachmentFolderPickerProperties } from './types/AttachmentFolderPickerProperties';
import { AttachmentFolderPickerResult } from './types/AttachmentFolderPickerResult';
import { LazyImport, LazyModule } from 'owa-bundling';
import {
    AttachmentSelectedFolderIdentifierType,
    AttachmentSelectedFolderInfo,
} from './types/AttachmentSelectedFolderInfo';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AttachmentFileProviderFolderPicker", webpackPrefetch: true */ './lazyIndex')
);

export const lazyShowAttachmentFolderPicker = new LazyImport(
    lazyModule,
    m => m.showAttachmentFolderPicker
);

export const lazyInitializeAttachmentFolderPicker = new LazyImport(
    lazyModule,
    m => m.initializeAttachmentFolderPicker
);

export {
    default as AttachmentDataProviderType,
} from 'owa-service/lib/contract/AttachmentDataProviderType';
export {
    AttachmentFolderPickerClientProviderType,
    AttachmentFolderPickerProviderType,
} from './store/schema/AttachmentFolderPickerProviderType';
export {
    AttachmentFolderPickerResult,
    AttachmentSelectedFolderIdentifierType,
    AttachmentSelectedFolderInfo,
    AttachmentFolderPickerProperties,
};
